import React from "react"

import Default from "../../Default"

const TermsOfService = () => {
  const title = "Resanec Terms and Conditions (T&C’s)"
  const description = (
    <>
      <p>Last updated: 9th December 2019</p>
      <p>
        Please read these Terms and Conditions (&quot;T&C’s) carefully before
        using the website{" "}
        <a href="https://www.resanec.com.au">www.resanec.com.au</a> operated by
        Resanec Pty Ltd.
      </p>
      <p>
        Your access to and use of our Service is conditioned on your acceptance
        of and compliance with these T&C’s. A User is considered to have
        accepted these T&C’s when the User acknowledges the T&C’s in order to
        use the Services provided as part of their registration or login.
      </p>
      <p>
        By accessing and using our Service you agree to be bound by these T&C’s
        If you disagree with any part of the terms then you may not access the
        Service.
      </p>

      <h2>Accounts</h2>
      <p>
        Each User Account is linked to a specific User and may not be used by
        any other person. A User may only access the Service using the allocated
        User Account.
      </p>
      <p>
        Each User must ensure that its User Account is protected at all times
        from misuse or any form of unauthorised use or access.  The User shall
        be responsible for the use, supervision, management and control of its
        User Account, including all activities that occur under the User Account
        with access to the relevant login details.  The User must notify Resanec
        Pty Ltd immediately if the User believes an unauthorised third party may
        be using or attempting to use their User Account.  Resanec Pty Ltd is
        not responsible for unauthorised access to a User Account.
      </p>
      <p>
        Use of the Service requires an internet connection.  Users will be
        responsible for all internet connection costs.
      </p>

      <h2>The Service</h2>
      <p>The User must not:</p>
      <ul>
        <li>
          copy, decompile, reverse-engineer, disassemble, attempt to derive the
          source code of, modify, tamper with or create derivative works of the
          Service, or any part thereof
        </li>
        <li>
          copy, rent, lease, lend, sell, resell, distribute, transfer or
          transfer all or any part of the Service
        </li>
        <li>
          provide access to the Service to any other non-registered person
        </li>
        <li>
          allow any person other than the nominated User to use or access a User
          Account;
        </li>
        <li>commercially exploit the Service</li>
        <li>distribute or transmit any part of the Service by any means.</li>
        <li>link to, frame or mirror any part of the Service</li>
        <li>
          use or encourage, promote, facilitate or instruct others to use the
          Service for any illegal, harmful or offensive use, or to transmit,
          store, display, distribute or otherwise make available content that is
          illegal, harmful or offensive.
        </li>
        <li>
          The User shall notify Resanec Pty Ltd immediately if the User becomes
          aware of any unauthorised use of the whole or part of the Service by
          any person.
        </li>
      </ul>

      <h2>User interaction</h2>
      <p>
        The Service enables the User to communicate with other users and to post
        material that may be made available to other Users.
      </p>
      <p>The User acknowledges and agrees that:</p>
      <ul>
        <li>
          any information or material submitted by the User may be viewed by
          other Users and by Resanec Pty Ltd
        </li>
        <li>
          the User will not use the Service to create, post or transmit:
          <ul>
            <li>
              any Intellectual Property or other material owned by another User
              that is contrary to their rights;
            </li>
            <li>any unsolicited advertising or promotional material;</li>
            <li>
              any material or information which is offensive, defamatory,
              obscene, unlawful, vulgar, harmful, threatening, abusive, amounts
              to harassment or is otherwise objectionable; or
            </li>
            <li>
              any material which contains viruses or other computer code, files
              or programs which are designed to limit or destroy the
              functionality of other computer software or hardware;
            </li>
          </ul>
        </li>
        <li>
          any Content may be removed by Resanec Pty Ltd without notice at any
          time, for any reason including no reason;
        </li>
        <li>
          Resanec Pty Ltd does not accept any responsibility or liability for
          the accuracy of Content made by other users of Service, and Resanec
          Pty Ltd is not liable for any loss or damage of any kind, or any
          claim, resulting from any action taken or reliance made by the User
          regarding any Content; and
        </li>
        <li>
          Resanec Pty Ltd is not responsible for resolving any disputes the User
          may have with other users of the Service.
        </li>
      </ul>

      <h2>Third-party software</h2>
      <p>
        In order to access and use the Service, the User may also be required to
        update third-party software (such as the operating system and web
        browser) on their device.  The User acknowledges and agrees that:
      </p>
      <ul>
        <li>Resanec Pty Ltd is not responsible for such third-party updates</li>
        <li>
          such third-party updates may be subject to their own terms and
          conditions, which Resanec Pty Ltd strongly recommends the User review
          prior to implementing the third-party update; and
        </li>
        <li>
          if the User is unable or unwilling to obtain or install such
          third-party updates, the User may be unable to access and use the
          Service.
        </li>
      </ul>

      <h2>Updates</h2>
      <p>Resanec Pty Ltd may, at its discretion:</p>
      <ul>
        <li>provide Updates to Users; and</li>
        <li>
          withdraw or disable previous versions of the Service from being used
          by Users.
        </li>
      </ul>
      <p>Resanec Pty Ltd</p>
      <ul>
        <li>is under no obligation to provide any Updates</li>
        <li>
          can use Updates to add, remove, modify or otherwise alter features of
          the Service at its sole discretion, and that such changes will not be
          a breach of this document
        </li>
        <li>
          can provide Updates in such a manner that the Service is unable to be
          reverted to its previous state.
        </li>
      </ul>

      <h2>Privacy</h2>
      <ul>
        <li>
          Resanec Pty Ltd undertakes to comply with the terms of its Privacy
          Policy, which can be view at : www.resanec.com.au/privacy
        </li>
        <li>
          In addition to the uses of information set out in Resanec Pty Ltd’s
          Privacy Policy, and notwithstanding anything to the contrary in these
          T&C’s, Resanec Pty Ltd may:
          <ul>
            <li>
              collect and analyse data relating to the provision, use and
              performance of various aspects of the Service and technologies,
              including:
              <ul>
                <li>
                  technical information about the Service, Devices and system
                  and
                </li>
                <li>
                  information concerning data provided by the User to Resanec
                  Pty Ltd
                </li>
              </ul>
            </li>
            <li>
              use such data to improve and enhance the Service and for other
              development, diagnostic and corrective purposes in connection with
              Resanec Pty Ltd’s offerings; and
            </li>
            <li>
              disclose such data in aggregate or other de-identified form in
              connection with Resanec Pty Ltd’s business.
            </li>
          </ul>
        </li>
      </ul>

      <h2>Intellectual property</h2>
      <p>
        Resanec Pty Ltd retains all right, title and interest to all
        Intellectual Property subsisting in the Service and any part thereof.
      </p>
      <p>
        This document does not constitute a transfer or conveyance of any
        Intellectual Property owned by Resanec Pty Ltd, including but not
        limited to Intellectual Property associated with the Service, and its
        functionality, features and content.
      </p>
      <p>
        Users acknowledge that the Service is protected by copyright and may
        also be protected as other forms of Intellectual Property owned by
        Resanec Pty Ltd.  Users undertake not to do or permit any act, either
        during or at any time after the termination of these T&C’s, which
        infringes or attempts to infringe those Intellectual Property rights
        and, without limiting the generality of the foregoing, Users
        specifically acknowledge that they must not copy the Service except as
        otherwise expressly authorised or acknowledged by these User Terms.
      </p>

      <h2>Effective date and termination</h2>
      <p>
        The licences granted under these User T&C’s are effective on the date
        the User enters into these User Terms, and will remain in force until
        terminated in accordance with its terms.
      </p>
      <p>
        The User may terminate these User Terms by deleting its User Account and
        discontinuing use of the Service.
      </p>
      <p>
        Resanec Pty Ltd may terminate these User T&C’s or suspend the
        User&apos;s access to the Service immediately if the User is in breach
        of any term of these User T&C’s or threatens to breach any term of these
        User T&C’s.
      </p>

      <h2>Acknowledgement and warranties</h2>
      <p>The User acknowledges that:</p>
      <ul>
        <li>
          it is the User&apos;s responsibility to ensure its systems will be
          compatible with, and suitable for its use of the Service
        </li>
        <li>
          the Service cannot be guaranteed to be error free and uninterrupted
        </li>
        <li>
          the Software and Services may be temporarily unavailable for
          maintenance, and although Resanec Pty Ltd will endeavour to provide
          advance notice of any scheduled service disruption, this will not be
          possible for unscheduled emergency maintenance or unexpected
          disruptions
        </li>
        <li>
          no data transmission over the internet can be guaranteed as totally
          secure;
        </li>
        <li>
          the User must take precautions to ensure that their processes for
          accessing the Service do not expose them to the risk of viruses,
          malicious computer code or other forms of interference which may
          damage their Devices or interrupt access to the Service; and
        </li>
        <li>
          any errors or disruptions outside Resanec Pty Ltd’s reasonable control
          will not constitute a breach of these User T&C’s by Op Central.
        </li>
      </ul>
      <p>
        Except as expressly provided to the contrary in this document, and to
        the full extent permitted by applicable law, Resanec Pty Ltd will not be
        liable for any loss, including special, indirect or consequential
        damages (such as loss of profits or time), or claim, arising out of
        breach of these User T&C’s or arising out of the supply of defective
        Service.
      </p>
      <p>
        The User acknowledges that it has not relied on any representation made
        by Resanec Pty Ltd which has not been stated expressly in these User
        T&C’s.
      </p>
      <p>
        The User will indemnify and keep indemnified Resanec Pty Ltd, its
        successors in title, their Related Bodies Corporate and their respective
        officers, employees and agents (those indemnified) from and against any
        loss (including reasonable legal costs and expenses) or liability
        incurred by any of those indemnified arising from any action, claim,
        demand, suit, action or proceeding whatsoever, whether presently
        existing or arising at any time in the future and whether referable to
        events or circumstances which have already occurred or which may occur
        in the future, where such loss or liability arose from:
      </p>
      <ul>
        <li>any breach of these User Terms by User;</li>
        <li>
          any act or omission of the User contrary to these User T&C’s or which
          would constitute a breach if it was done or omitted to be done by the
          User; or
        </li>
        <li>
          any warranty given by the User proving to have been false, misleading
          or inaccurate when made.
        </li>
      </ul>
      <p>
        Resanec Pty Ltd is entitled to enforce any indemnity as trustee on
        behalf of those indemnified.
      </p>

      <h2>Links To Other Web Sites</h2>
      <p>
        Our Service may contain links to third-party web sites or services that
        are not owned or controlled by Resanec Pty Ltd.
      </p>
      <p>
        Resanec Pty Ltd has no control over, and assumes no responsibility for,
        the content, privacy policies, or practices of any third party web sites
        or services. You further acknowledge and agree that Resanec Pty Ltd
        shall not be responsible or liable, directly or indirectly, for any
        damage or loss caused or alleged to be caused by or in connection with
        use of or reliance on any such content, goods or services available on
        or through any such web sites or services.
      </p>

      <h2>Changes</h2>
      <p>
        Resanec Pty Ltd reserve the right, at our sole discretion, to modify or
        replace these T&C’s at any time. If a revision is material we will try
        to provide at least 30 days notice prior to any new T&C’s taking effect.
        What constitutes a material change will be determined at our sole
        discretion.
      </p>

      <h2>General</h2>
      <p>
        These User T&C’s are governed by and is to be construed under the laws
        in force in the State of Victoria, Australia.  Each party submits to the
        non-exclusive jurisdiction of the courts exercising jurisdiction in
        Victoria and courts of appeal from them in respect of any proceedings
        arising out of or in connection with these User T&C’s.  Each party
        irrevocably waives any objection to the venue of any legal process in
        these courts on the basis that the process has been brought in an
        inconvenient forum.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about these T&C’s, please contact us.
        <br />
        Resanec Pty Ltd (ABN 30 631 781 729)
        <br />
        PO BOX 3356
        <br />
        Burnley North
        <br />
        (Victoria Gardens)
        <br />
        Abbotsford VIC 3121
        <br />
        <br />
        or
        <br />
        E: <a href="mailto:admin@resanec.com.au">admin@resanec.com.au</a>
      </p>
    </>
  )
  return <Default title={title} description={description} />
}

export default TermsOfService
